var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("法律服务")]),
              _c("el-breadcrumb-item", [_vm._v("浏览统计")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            {
              ref: "listForm",
              attrs: {
                model: _vm.listParams,
                "label-width": "120px",
                inline: "",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "栏目名称：", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入栏目名称", clearable: "" },
                    model: {
                      value: _vm.listParams.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.listParams, "name", $$v)
                      },
                      expression: "listParams.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "栏目类型：", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择栏目类型", clearable: "" },
                      model: {
                        value: _vm.listParams.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.listParams, "type", $$v)
                        },
                        expression: "listParams.type",
                      },
                    },
                    _vm._l(_vm.ColumnTypeList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.handleRefresh },
                    },
                    [_vm._v(" 查询 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.resetForm("listForm")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.dataLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("icTableColumnIndex", {
                attrs: {
                  pageIndex: _vm.pager.pageIndex,
                  pageSize: _vm.pager.pageSize,
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "name", align: "left", label: "栏目名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "content", align: "left", label: "栏目内容" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.content
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.content.length > 100
                                      ? scope.row.content.substring(0, 100) +
                                          "..."
                                      : scope.row.content
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "type", align: "center", label: "栏目类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.ColumnTypeMap[scope.row.type])),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "seeNumber", align: "center", label: "浏览量" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }